import { useQuery } from '@tanstack/react-query';
import { API } from '~/shared/API/api';

export const useGetPastRents = (
  type: 'in_progress' | 'completed' | 'payed',
  autoRefetch?: boolean
) => {
  const { data, isLoading, refetch, isSuccess } = useQuery({
    queryKey: ['rents', type],
    queryFn: () => API.getPastRents(type),
    //retry: 1,
    select: (data) => data.data.payload,
    refetchOnWindowFocus: 'always',
    refetchInterval: autoRefetch ? 2000 : false,
  });

  return { pastRents: data, isLoading, refetch, isSuccess };
};
